(function () {
  'use strict';

  var MAPLIBRE_CSS = 'https://unpkg.com/maplibre-gl@5/dist/maplibre-gl.css';
  var MAPLIBRE_JS = 'https://unpkg.com/maplibre-gl@5/dist/maplibre-gl.js';
  var MAPLIBRE_JS_FALLBACK = 'https://cdn.jsdelivr.net/npm/maplibre-gl@5/dist/maplibre-gl.js';
  var LOGO_FALLBACK = 'https://cdn.shopify.com/s/files/1/0691/6476/1304/files/logo_header_2.png?v=1717437457';
  var STYLE_BASE = 'https://tiles.openfreemap.org/styles/';

  function number(value, fallback) {
    var parsed = Number(String(value == null ? '' : value).replace(',', '.').trim());
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function validCoord(lat, lng) {
    return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
  }

  function normalize(value) {
    var str = String(value || '');
    try { str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return str.toLowerCase().trim();
  }

  function maybeFixItalyCoords(lat, lng, country) {
    if (!validCoord(lat, lng)) return { lat: lat, lng: lng };
    var c = normalize(country);
    var italy = !c || c.indexOf('ital') !== -1;
    if (!italy) return { lat: lat, lng: lng };

    var normalItaly = lat >= 35 && lat <= 48.8 && lng >= 6 && lng <= 19.2;
    var swappedItaly = lng >= 35 && lng <= 48.8 && lat >= 6 && lat <= 19.2;
    if (!normalItaly && swappedItaly) return { lat: lng, lng: lat };
    return { lat: lat, lng: lng };
  }

  function distanceKm(lat1, lng1, lat2, lng2) {
    var radius = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function ensureCss() {
    if (document.querySelector('link[data-blu-maplibre-css]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = MAPLIBRE_CSS;
    link.setAttribute('data-blu-maplibre-css', '');
    document.head.appendChild(link);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-blu-maplibre-js][src="' + src + '"]');
      if (existing) {
        if (window.maplibregl) return resolve(window.maplibregl);
        existing.addEventListener('load', function () { resolve(window.maplibregl); }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-blu-maplibre-js', '');
      script.onload = function () { resolve(window.maplibregl); };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadMapLibre() {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (window.__bluMapLibrePromise) return window.__bluMapLibrePromise;

    ensureCss();
    window.__bluMapLibrePromise = loadScript(MAPLIBRE_JS).catch(function () {
      return loadScript(MAPLIBRE_JS_FALLBACK);
    }).then(function () {
      if (!window.maplibregl) throw new Error('MapLibre non disponibile');
      return window.maplibregl;
    });

    return window.__bluMapLibrePromise;
  }

  function getStyleUrl(section) {
    var selected = section.dataset.mapStyle || 'positron';
    if (selected === 'custom' && section.dataset.customStyleUrl) return section.dataset.customStyleUrl;
    if (selected !== 'liberty' && selected !== 'bright' && selected !== 'positron') selected = 'positron';
    return STYLE_BASE + selected;
  }

  function initSection(section) {
    if (!section || section.__bluStoreStarting) return;
    if (section.__bluStoreCleanup) section.__bluStoreCleanup();
    section.__bluStoreStarting = true;

    var mapNode = section.querySelector('[data-blu-map]');
    var mapStatus = section.querySelector('[data-blu-map-status]');
    var listNode = section.querySelector('[data-blu-store-list]');
    var searchInput = section.querySelector('[data-blu-store-search]');
    var locationButton = section.querySelector('[data-blu-use-location]');
    var locationLabel = section.querySelector('[data-blu-location-label]');
    var noticeNode = section.querySelector('[data-blu-store-notice]');

    if (!mapNode || !listNode) {
      section.__bluStoreStarting = false;
      return;
    }

    var initialLocationText = locationLabel ? locationLabel.textContent : '';
    var markerLogo = section.dataset.markerLogo || LOGO_FALLBACK;
    var selectedLabel = section.dataset.selectedLabel || 'Boutique selezionata';
    var storeLabel = section.dataset.storeLabel || 'Boutique';
    var directionsLabel = section.dataset.directionsLabel || 'Indicazioni';
    var phoneLabel = section.dataset.phoneLabel || 'Chiama';
    var emailLabel = section.dataset.emailLabel || 'Email';
    var showInitialSelected = section.dataset.showInitialSelected === 'true';
    var autoLocation = section.dataset.autoLocation === 'true';
    var defaultLat = number(section.dataset.defaultLat, 41.9028);
    var defaultLng = number(section.dataset.defaultLng, 12.4964);
    var defaultZoom = number(section.dataset.defaultZoom, 7);

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-blu-store-card]'));
    var stores = cards.map(function (card, index) {
      var rawLat = number(card.dataset.lat, null);
      var rawLng = number(card.dataset.lng, null);
      var fixed = maybeFixItalyCoords(rawLat, rawLng, card.dataset.country || '');
      return {
        index: index,
        card: card,
        name: card.dataset.name || '',
        address: card.dataset.address || '',
        city: card.dataset.city || '',
        cap: card.dataset.cap || '',
        province: card.dataset.province || '',
        country: card.dataset.country || '',
        phone: card.dataset.phone || '',
        email: card.dataset.email || '',
        mapUrl: card.dataset.mapUrl || '',
        order: number(card.dataset.order, index + 1),
        lat: fixed.lat,
        lng: fixed.lng,
        visible: true,
        distance: null,
        marker: null,
        markerEl: null
      };
    }).filter(function (store) {
      return validCoord(store.lat, store.lng);
    }).sort(function (a, b) {
      return a.order - b.order;
    });

    if (!stores.length) {
      if (mapStatus) {
        mapStatus.hidden = false;
        mapStatus.textContent = 'Inserisci latitudine e longitudine valide nei metaobject degli store.';
      }
      section.__bluStoreStarting = false;
      return;
    }

    var map = null;
    var userMarker = null;
    var userPosition = null;
    var searchTimer = null;
    var destroyed = false;
    var listeners = [];

    function on(node, eventName, handler, options) {
      if (!node) return;
      node.addEventListener(eventName, handler, options);
      listeners.push(function () { node.removeEventListener(eventName, handler, options); });
    }

    function visibleStores() {
      return stores.filter(function (store) { return store.visible; });
    }

    function directionUrl(store) {
      return store.mapUrl || ('https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(store.lat + ',' + store.lng));
    }

    function resetStoreLabels() {
      stores.forEach(function (item) {
        var kicker = item.card.querySelector('[data-blu-store-kicker]');
        if (kicker) kicker.textContent = storeLabel;
      });
    }

    function restoreListOrder() {
      var ordered = stores.slice();
      if (userPosition) {
        ordered.sort(function (a, b) {
          var da = Number.isFinite(a.distance) ? a.distance : Number.POSITIVE_INFINITY;
          var db = Number.isFinite(b.distance) ? b.distance : Number.POSITIVE_INFINITY;
          return da - db;
        });
      } else {
        ordered.sort(function (a, b) { return a.order - b.order; });
      }
      ordered.forEach(function (item) { listNode.appendChild(item.card); });
    }

    function setActive(store, options) {
      if (!store) return;
      options = options || {};

      resetStoreLabels();
      stores.forEach(function (item) {
        var active = item === store;
        item.card.classList.toggle('is-active', active);
        item.card.setAttribute('aria-current', active ? 'true' : 'false');
        if (item.markerEl) item.markerEl.classList.toggle('is-active', active);
      });

      var kicker = store.card.querySelector('[data-blu-store-kicker]');
      if (kicker) kicker.textContent = selectedLabel;

      /* Lo store selezionato diventa la prima card della lista: niente duplicati. */
      if (listNode && store.card.parentNode === listNode) {
        listNode.insertBefore(store.card, listNode.firstChild);
      }

      if (map && options.move !== false) {
        map.easeTo({
          center: [store.lng, store.lat],
          zoom: Math.max(map.getZoom(), 14.5),
          duration: options.instant ? 0 : 380,
          essential: true
        });
      }
      var panel = section.querySelector('.blu-store-locator__panel');
      if (window.innerWidth < 750 && panel) {
        /* On mobile the selected store is moved to the first position. Keep the
           horizontal carousel aligned to that card without moving the page. */
        window.requestAnimationFrame(function () {
          panel.scrollTo({ left: 0, behavior: options.instant ? 'auto' : 'smooth' });
        });
      } else if (options.scrollCard && store.card && panel) {
        window.requestAnimationFrame(function () {
          var targetTop = Math.max(0, store.card.offsetTop - 8);
          panel.scrollTo({ top: targetTop, behavior: options.instant ? 'auto' : 'smooth' });
        });
      }
    }

    function createStoreMarker(store, maplibregl) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'blu-map-store-marker';
      button.setAttribute('aria-label', store.name);
      button.innerHTML = '<span class="blu-map-store-marker__inner"><img src="' + escapeHtml(markerLogo) + '" alt=""></span>';
      store.markerEl = button;
      store.marker = new maplibregl.Marker({ element: button, anchor: 'center' })
        .setLngLat([store.lng, store.lat])
        .addTo(map);
      on(button, 'click', function () { setActive(store, { move: true, scrollCard: false }); });
    }

    function fitStores(items, options) {
      if (!map || !items.length) return;
      options = options || {};
      var maplibregl = window.maplibregl;
      if (items.length === 1) {
        map.easeTo({ center: [items[0].lng, items[0].lat], zoom: options.zoom || 13.5, duration: options.duration || 0 });
        return;
      }
      var bounds = new maplibregl.LngLatBounds();
      items.forEach(function (item) { bounds.extend([item.lng, item.lat]); });
      map.fitBounds(bounds, {
        padding: window.innerWidth < 750 ? 52 : 80,
        maxZoom: options.maxZoom || 12,
        duration: options.duration || 0
      });
    }

    function refreshMarkers() {
      stores.forEach(function (store) {
        if (!store.markerEl) return;
        store.markerEl.style.display = store.visible ? '' : 'none';
      });
    }

    function applySearch() {
      var query = normalize(searchInput ? searchInput.value : '');
      var count = 0;
      stores.forEach(function (store) {
        var haystack = normalize([store.name, store.address, store.city, store.cap, store.province, store.country].join(' '));
        store.visible = !query || haystack.indexOf(query) !== -1;
        store.card.hidden = !store.visible;
        if (store.visible) count += 1;
      });
      refreshMarkers();
      resetStoreLabels();
      stores.forEach(function (store) {
        store.card.classList.remove('is-active');
        store.card.removeAttribute('aria-current');
        if (store.markerEl) store.markerEl.classList.remove('is-active');
      });
      restoreListOrder();
      if (noticeNode) noticeNode.textContent = count ? '' : 'Nessuno store trovato per questa ricerca.';
      var visible = visibleStores();
      if (visible.length) fitStores(visible, { duration: 250 });
    }

    function resetLocationButton() {
      if (locationButton) locationButton.disabled = false;
      if (locationLabel) locationLabel.textContent = initialLocationText;
    }

    function showUserPosition(position, options) {
      options = options || {};
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      userPosition = { lat: lat, lng: lng };

      if (!map) return;
      if (userMarker) userMarker.remove();
      var markerEl = document.createElement('div');
      markerEl.className = 'blu-map-user-marker';
      markerEl.setAttribute('aria-label', 'La tua posizione');
      userMarker = new window.maplibregl.Marker({ element: markerEl, anchor: 'center' })
        .setLngLat([lng, lat])
        .addTo(map);

      stores.forEach(function (store) {
        store.distance = distanceKm(lat, lng, store.lat, store.lng);
        var node = store.card.querySelector('[data-blu-store-distance]');
        if (node) {
          node.textContent = store.distance < 1
            ? Math.round(store.distance * 1000) + ' m'
            : store.distance.toFixed(1).replace('.', ',') + ' km';
        }
      });

      var distanceOrder = stores.slice().sort(function (a, b) { return a.distance - b.distance; });
      distanceOrder.forEach(function (store) { listNode.appendChild(store.card); });

      var nearest = distanceOrder[0];
      if (nearest && options.focus !== false) {
        setActive(nearest, { move: false, scrollCard: options.scrollCard !== false });
        var bounds = new window.maplibregl.LngLatBounds();
        bounds.extend([lng, lat]);
        bounds.extend([nearest.lng, nearest.lat]);
        map.fitBounds(bounds, {
          padding: window.innerWidth < 750 ? 58 : 100,
          maxZoom: 14.5,
          duration: options.instant ? 0 : 500
        });
        if (noticeNode) {
          noticeNode.textContent = 'Store più vicino: ' + nearest.name + ' · ' + nearest.distance.toFixed(1).replace('.', ',') + ' km.';
        }
      } else if (options.centerOnly) {
        map.easeTo({ center: [lng, lat], zoom: Math.max(map.getZoom(), 13.5), duration: options.instant ? 0 : 450 });
      }

      resetLocationButton();
    }

    function requestLocation(options) {
      options = options || {};
      if (!navigator.geolocation) {
        if (noticeNode) noticeNode.textContent = 'La geolocalizzazione non è disponibile su questo dispositivo.';
        return;
      }
      if (locationButton && options.showLoading !== false) locationButton.disabled = true;
      if (locationLabel && options.showLoading !== false) locationLabel.textContent = 'Ricerca posizione…';
      if (noticeNode && options.clearNotice !== false) noticeNode.textContent = '';

      navigator.geolocation.getCurrentPosition(function (position) {
        showUserPosition(position, options);
      }, function (error) {
        resetLocationButton();
        if (options.silent) return;
        if (noticeNode) {
          if (error && error.code === 1) noticeNode.textContent = 'Consenti l’accesso alla posizione nel browser e riprova.';
          else noticeNode.textContent = 'Non siamo riusciti a rilevare la tua posizione. Riprova oppure cerca per città o CAP.';
        }
      }, {
        enableHighAccuracy: true,
        timeout: 12000,
        maximumAge: 180000
      });
    }

    if (searchInput) {
      on(searchInput, 'input', function () {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(applySearch, 160);
      });
      on(searchInput, 'keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        applySearch();
        var first = visibleStores()[0];
        if (first) setActive(first, { move: true, scrollCard: false });
      });
    }

    if (locationButton) {
      on(locationButton, 'click', function () {
        requestLocation({ focus: true, scrollCard: false, showLoading: true });
      });
    }

    stores.forEach(function (store) {
      var focus = store.card.querySelector('[data-blu-store-focus]');
      if (focus) on(focus, 'click', function () { setActive(store, { move: true, scrollCard: false }); });
    });

    if (mapStatus) {
      mapStatus.hidden = false;
      mapStatus.textContent = 'Caricamento mappa…';
    }

    loadMapLibre().then(function (maplibregl) {
      if (destroyed) return;

      var mobileMapMode = window.matchMedia('(max-width: 749px)').matches || window.matchMedia('(pointer: coarse)').matches;

      map = new maplibregl.Map({
        container: mapNode,
        style: getStyleUrl(section),
        center: [defaultLng, defaultLat],
        zoom: defaultZoom,
        attributionControl: false,
        cooperativeGestures: false,
        dragPan: !mobileMapMode,
        touchZoomRotate: !mobileMapMode
      });

      map.dragRotate.disable();
      if (map.scrollZoom) map.scrollZoom.disable();

      /* Mobile: the map must never trap the vertical page scroll. */
      if (mobileMapMode) {
        if (map.dragPan) map.dragPan.disable();
        if (map.touchZoomRotate) map.touchZoomRotate.disable();
        if (map.doubleClickZoom) map.doubleClickZoom.disable();
      } else if (map.touchZoomRotate) {
        map.touchZoomRotate.disableRotation();
      }

      map.addControl(new maplibregl.NavigationControl({ showCompass: false, visualizePitch: false }), 'top-right');
      map.addControl(new maplibregl.AttributionControl({ compact: true }), 'bottom-right');

      map.on('load', function () {
        if (destroyed) return;
        stores.forEach(function (store) { createStoreMarker(store, maplibregl); });
        refreshMarkers();
        fitStores(stores, { duration: 0 });
        if (showInitialSelected && stores[0]) setActive(stores[0], { move: false });
        if (mapStatus) mapStatus.hidden = true;

        window.setTimeout(function () { if (map && !destroyed) map.resize(); }, 80);
        window.setTimeout(function () { if (map && !destroyed) map.resize(); }, 350);

        if (autoLocation && navigator.permissions && navigator.permissions.query) {
          navigator.permissions.query({ name: 'geolocation' }).then(function (permission) {
            if (permission.state === 'granted') {
              requestLocation({ focus: false, centerOnly: false, scrollCard: false, showLoading: false, clearNotice: false, silent: true, instant: true });
            }
          }).catch(function () {});
        }
      });

      map.on('error', function (event) {
        if (!event || !event.error) return;
        var message = String(event.error.message || '');
        if (message.toLowerCase().indexOf('style') !== -1 && mapStatus) {
          mapStatus.hidden = false;
          mapStatus.textContent = 'Non riesco a caricare lo stile della mappa. Controlla la connessione o l’URL dello stile.';
        }
      });
    }).catch(function () {
      if (destroyed) return;
      if (mapStatus) {
        mapStatus.hidden = false;
        mapStatus.textContent = 'Non riesco a caricare la mappa. Ricarica la pagina e riprova.';
      }
    }).finally(function () {
      section.__bluStoreStarting = false;
    });

    section.__bluStoreCleanup = function () {
      destroyed = true;
      window.clearTimeout(searchTimer);
      listeners.forEach(function (off) { try { off(); } catch (e) {} });
      if (userMarker) { try { userMarker.remove(); } catch (e) {} }
      stores.forEach(function (store) {
        if (store.marker) { try { store.marker.remove(); } catch (e) {} }
      });
      if (map) { try { map.remove(); } catch (e) {} }
      section.__bluStoreStarting = false;
      section.__bluStoreCleanup = null;
    };
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-blu-store-locator]')) initSection(scope);
    var nodes = scope.querySelectorAll ? scope.querySelectorAll('[data-blu-store-locator]') : [];
    Array.prototype.forEach.call(nodes, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.matches && event.target.matches('[data-blu-store-locator]')
      ? event.target
      : event.target && event.target.querySelector
        ? event.target.querySelector('[data-blu-store-locator]')
        : null;
    if (section && section.__bluStoreCleanup) section.__bluStoreCleanup();
  });
})();
